export interface Measurements {
  depth: number;
  width: number;
  height: number;
}
